<template>
  <div class="head clearfix">
    <div class="content clearfix">
      <div class="logo fl">
        <router-link to="/">
          <!--<svg-icon icon-class="logo"></svg-icon>-->
          <img :src="protalLogoUrl" />
        </router-link>
      </div>
      <div class="search fl">
        <el-input
          class="search-input fl"
          v-model="name"
          :placeholder="$t('page.content.searchPlaceholder')"
        ></el-input>
        <el-button type="text" class="search-btn fl" @click="search">{{
          $t("page.content.search")
        }}</el-button>
      </div>
      <div class="clearfix"></div>
      <div class="classes">
        <ul v-if="isJRZL == '1'" class="menu">
          <div
            class="menu-item"
            v-for="(item, index) in brandListJRW"
            :key="index"
          >
            <li class="menu-item-li" v-if="item.to" @click="activeIndexJRW = 0">
              <router-link
                v-if="item.to"
                :to="item.to"
                :class="activeIndexJRW == item.activeIndex ? 'line-hight' : ''"
              >
                {{ item.name }}
              </router-link>
            </li>
            <li class="menu-item-li" v-else>
              <a
                @click="handleClickJRW(item)"
                :class="activeIndexJRW == item.activeIndex ? 'line-hight' : ''"
                >{{ item.name }}</a
              >
            </li>
          </div>
        </ul>
        <div v-else>
          <div :class="['all-classes fl', hoverClass]" ref="catalogInfo">
            {{ $t("page.content.all") }}
            <div class="catalog-info-hide">
              <div class="catalog-info">
                <ul class="cate-menu">
                  <template v-for="(item, index) in catalogList">
                    <li :key="index" class="catalog-li">
                      <div style="position: relative;">
                        <img class="pr-5 catalog-img" :src="item.coverUrl" />
                        <div class="pl20 catalog-item ell">
                          <template v-for="(item1, index1) in item.children">
                            <el-link
                              :key="index1"
                              :underline="false"
                              @click="handleClickCategory(item1)"
                              class="mr5"
                              >{{ item1.categoryName }}</el-link
                            >
                          </template>
                        </div>
                      </div>
                    </li>
                  </template>
                </ul>
              </div>
            </div>
          </div>
          <el-menu
            :default-active="activeIndex"
            class="el-menu-demo"
            mode="horizontal"
            active-text-color="#0089EF"
          >
            <template v-for="(item, index) in showFilter(brandList)">
              <el-menu-item :key="index">
                <router-link
                  v-if="item.to"
                  :to="item.to"
                  :style="{ fontSize: fontSize ? '13px' : '16px' }"
                >
                  {{ item.name }}
                </router-link>
                <a
                  @click="handleClick(item)"
                  v-else
                  :style="{ fontSize: fontSize ? '13px' : '16px' }"
                  >{{ item.name }}</a
                >
              </el-menu-item>
            </template>
          </el-menu>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import store from "@/config/store";
import { mixinHomePage } from "../../../mixins/mixin-common/mixin-homePage";
import { getMailAddress } from "../api/shopping";
import Cookies from "js-cookie";

export default {
  name: "shopHead",
  mixins: [mixinHomePage],
  data() {
    return {
      activeIndex: "0",
      activeIndexJRW: "0",
      protalLogoUrl: "",
      brandList: [
        {
          name: this.$t("page.content.menu1"), //首页
          type: 1,
          to: "/",
          show: true
        },
        {
          name: this.$t("page.content.menu6"), //业务协同
          type: 6,
          show: !!Cookies.get("access_token")
        },
        {
          name: this.$t("page.content.menu7"), //站内信
          type: 7,
          show: !!Cookies.get("access_token")
        },
        {
          name: this.$t("page.content.menu8"), //供应商信息变更
          type: 8,
          show: !!Cookies.get("access_token")
        },
        {
          name: this.$t("page.content.menu9"), //合作意向申请
          type: 9,
          show: !!Cookies.get("access_token")
        },
        {
          name: this.$t("page.content.menu10"), //联系我们
          type: 10,
          show: true
        }
        //{
        //name: this.$t("page.content.menu11"), //云租APP
        //type: 11,
        //show: true
        //}
        // {
        //   name: this.$t("page.content.menu4"), //供应商注册
        //   type: 4,
        //   show: true
        // }
        // {
        //   name: this.$t("page.content.menu2"), //集中采购
        //   type: 2
        // },
        // {
        //   name: this.$t("page.content.menu3"), //区域联采
        //   type: 3
        // },
        // {
        //   name: this.$t("page.content.menu4"), //供应商注册
        //   type: 4
        // },
        // {
        //   name: this.$t("page.content.menu5"), //供应链金融
        //   type: 5
        // }
      ],
      brandListJRW: [
        {
          name: "首页", //首页
          type: 1,
          activeIndex: "0",
          show: true
        },
        {
          name: "采购公告", //物资设备采购
          type: 3,
          activeIndex: "2"
          // show: !!Cookies.get("access_token")
        },
        {
          name: "工程分包", //工程专区
          type: 2,
          activeIndex: "1"
          // show: !!Cookies.get("access_token")
        },
        {
          name: "云采商城", //商城采购
          type: 4,
          activeIndex: "3"
          // show: !!Cookies.get("access_token")
        },
        {
          name: "资源共享", //资源共享
          type: 5,
          activeIndex: "4"
          // show: !!Cookies.get("access_token")
        },
        {
          name: "运输物流", //运输物流
          type: 6,
          activeIndex: "5"
          // show: !!Cookies.get("access_token")
        },
        {
          name: "智慧云仓", //智慧云仓
          type: 7,
          activeIndex: "6"
          // show: !!Cookies.get("access_token")
        },
        {
          name: "供应链金融", //供应链金融
          type: 8,
          activeIndex: "7"
          // show: !!Cookies.get("access_token")
        }
        // {
        //   name: "合作商", //合作商 (本期暂时不上)
        //   type: 9,
        //   activeIndex: "8"
        //   // show: !!Cookies.get("access_token")
        // }
      ],
      name: this.$route.query.name,
      isJRZL: this.$route.query.isJRZL,
      breadType: this.$route.query.breadType || "0"
    };
  },
  created() {
    // this.protalLogoUrl = sessionStorage.getItem("isJRZL")
    //   ? require("@/basa/assets/images/jiaorongzhilian.png")
    //   : require("@/basa/assets/images/protalLogo.png");
    this.protalLogoUrl = require("@/basa/assets/images/jiaorongzhilian.png");
    this.activeIndexJRW = this.breadType === "13" ? "0" : "2";
  },
  methods: {
    search() {
      this.$router.push({
        path: "/searchList",
        query: {
          ...this.$route.query,
          name: this.name,
          v: Math.random()
        }
      });
    },
    showFilter(list) {
      let newList = list.filter(item => {
        return item.show === true;
      });
      return newList;
    },
    handleClick(item) {
      if (item.type === 4) {
        window.open(
          `${this.$addUrlPerFix(process.env.VUE_APP_SRA_URL)}/maReady01`
        );
      }
      if (item.type === 6) {
        window.open(
          `${this.$addUrlPerFix(
            process.env.VUE_APP_CRMA_URL
          )}/bid/homePage?a=` + sessionStorage.getItem("param_a")
        );
      }
      if (item.type === 7) {
        getMailAddress({}).then(res => {
          if (res.data.code === "0") {
            window.open(
              this.$addUrlPerFix(`crma.iccec.cn${res.data.data.address}`)
            );
          }
        });
      }
      if (item.type === 8) {
        getMailAddress({}).then(res => {
          if (res.data.code === "0") {
            window.open(
              this.$addUrlPerFix(
                `crma.iccec.cn/infoMaintain/infoChangeChangeList?a=${res.data.data.agentId}`
              )
            );
          }
        });
      }
      if (item.type === 9) {
        getMailAddress({}).then(res => {
          if (res.data.code === "0") {
            window.open(
              this.$addUrlPerFix(
                `crma.iccec.cn/infoMaintain/cooperatorApplyCooperationApply?a=${res.data.data.agentId}`
              )
            );
          }
        });
      }
      if (item.type === 10) {
        let url = this.$router.resolve({
          path: "/contactUs",
          query: {}
        });
        window.open(url.href, "_blank");
      }
      // if (item.type === 11) {
      //   let protocol = window.location.protocol;
      //   protocol +=
      //     "//oss-znlhzl.oss-cn-shanghai.aliyuncs.com/apk/prd/prd-hatch-zj/V1.0.1/app-release.apk";
      //   window.open(protocol);
      // }
      // if (item.type === 4) {
      //   window.open(this.$addUrlPerFix("sra.iccec.cn/maReady01"));
      // }
    },
    handleClickJRW(item) {
      if (item.type === 1) {
        // 交融网: jrw.iccec.cn
        location.href = `${this.$addUrlPerFix(process.env.VUE_APP_JRW_URL)}`;
      }
      if (item.type === 2) {
        // 跳转分包电子采购共享平台首页: scp.iccec.cn
        location.href = `${this.$addUrlPerFix(process.env.VUE_APP_SCP_URL)}`;
      }
      if (item.type === 3) {
        // 跳转中交供应商门户首页: sp.iccec.cn
        this.activeIndexJRW = 2;
        location.href = `${this.$addUrlPerFix(
          process.env.VUE_APP_JRW_URL
        )}/procurementNotice`;
        // location.href=(`${this.$addUrlPerFix(process.env.VUE_APP_SP_URL)}`);
      }
      if (item.type === 4) {
        // 跳转交建云商专区首页: emp.iccec.cn
        location.href = `${this.$addUrlPerFix(process.env.VUE_APP_EMP_URL)}`;
      }
      if (item.type === 5) {
        // 跳转中交资源共享专区首页: clp.iccec.cn
        location.href = `${this.$addUrlPerFix(process.env.VUE_APP_CLP_URL)}`;
      }
      if (item.type === 6) {
        // 跳转运输物流专区首页: wuliuyun.iccec.cn
        location.href = `${this.$addUrlPerFix(process.env.VUE_APP_WLY_URL)}`;
      }
      if (item.type === 7) {
        // 跳转智慧云仓专区首页: yuncang.iccec.cn
        location.href = `${this.$addUrlPerFix(process.env.VUE_APP_YC_URL)}`;
      }
      if (item.type === 8) {
        // 跳转供应链金融专区首页: jr.iccec.cn
        location.href = `${this.$addUrlPerFix(process.env.VUE_APP_JR_URL)}`;
      }
    }
  },
  computed: {
    catalogList() {
      return store.state.user.catalogList;
    },
    fontSize() {
      return (
        !!Cookies.get("access_token") &&
        !((Cookies.get("language") || "zh-cn") === "zh-cn")
      );
    },
    hoverClass() {
      if (!store.state.user.isPortal) {
        return "catalog-info-hover";
      } else {
        return "";
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.el-input /deep/ input.el-input__inner {
  border: none !important;
}

.svg-icon {
  width: 100% !important;
  height: 68px !important;
}
.menu {
  height: 40px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  .menu-item {
    margin: 0 !important;
    padding-left: 0 !important;
    padding-right: 30px !important;
    font-size: 16px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    color: #333333;
  }
}
.line-hight {
  color: #0089ef;
}
</style>
